import { freeze } from 'utils/dom'

// const DEBUG_LEVEL = 4
// export function authDebug(level, message, data) {
//   if (level <= DEBUG_LEVEL) {
//     console.log(message, data)
//   }
// }
export const authDebug = (_a, _b, _c) => {}

export const VALIDATION_KEY = 'codex'

export const R_SIGNON = freeze({
  SIGNING_IN: Symbol('SIGNING_IN'),
  SIGNED_IN: Symbol('SIGNED_IN'),
  SIGN_OUT: Symbol('SIGN_OUT'),
  SIGNIN_TIMEOUT: Symbol('SIGNIN_TIMEOUT'),
  MERGE: Symbol('MERGE'),
  ERROR: Symbol('ERROR'),
  ERROR_CLEAR: Symbol('ERROR_CLEAR'),
  ERROR_REDIRECT: Symbol('ERROR_REDIRECT'),
  RELOAD_USER: Symbol('RELOAD_USER')
})

export const initialState = freeze({
  handshaking: false, // are we in the middle of a signin sequence? - used by the Signon frontend
  error: undefined,
  reloadUser: 0, // increment to trigger a user reload
  refreshToken: 0 // incrment to trigger a token refresh
})
